export default "__VITE_ASSET__DJe0hSWb__"